import { Component, ChangeDetectorRef, ViewChild, ElementRef, Input } from '@angular/core';
import { DispatchesService } from '../shared/services/dispatches.service';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import { SelectEvent } from '@progress/kendo-angular-layout';
import { UntypedFormGroup, UntypedFormControl, Validators, FormControl } from '@angular/forms';
import { AdditionalDispatchData } from '../shared/models/AdditionalDispatchData';
import { DispatchBus } from '../shared/models/DispatchBus';
import { DispatchPage } from '../shared/models/DispatchPage';
import { DispatchSummary } from '../shared/models/DispatchSummary';
import { DQOIService } from '../shared/services/DQOI.service';
import { SearchTarget } from '../shared/enums/SearchTarget';
import { BaseDQOIComponent } from '../shared/base-components/base-dqoi.component';
import { GlobalsService } from '../shared/services/globals.service';
import { DQOIReferenceDataQuery } from '../dqoi/state/dqoi-reference-data.query';
import { GItem } from '../shared/models/GItem';
import { CommonFunctions } from '../shared/static/common-functions';
import { DQOIState } from '../shared/models/DQOIState';
import { DateFunctions } from '../shared/static/date-functions';
import { MessageType } from '../shared/enums/MessageType';
import { DispatchMessageInfo } from '../shared/models/DispatchMessageInfo';
import { DQOIItem } from '../shared/models/DQOIItem';
import { CommonValues } from '../shared/static/CommonValues';
import { Message } from '../shared/models/message';
import { BaseMessageInfo } from '../shared/models/BaseMessageInfo';
import { Email } from '../shared/models/Email';
import { CommonParam } from '../shared/models/CommonParam';
import { DQOIParam } from '../shared/models/DQOIParam';
import { DispatchNoteBus } from '../shared/models/DispatchNoteBus';
import { DispatchNotesComponent } from './dispatch-notes/dispatch-notes.component';
import { DispatchAssignmentsComponent } from './assignments/dispatch-assignments.component';
import { DispatchEquipSvcdComponent } from './equipment/serviced/dispatch-equip-svcd.component';
import { DispatchPartsRequestedComponent } from './parts/requested/dispatch-parts-requested.component';
import { DispatchCustomerSuppliedPartsComponent } from './parts/customer-supplied/dispatch-customer-supplied-parts.component';
import { DispatchLaborComponent } from './labor/dispatch-labor.component';
import { DispatchErrorsComponent } from './errors/dispatch-errors.component';
import { WorkOrderAttachmentsComponent } from './attachments/workorder-attachments.component';
import { SaveMode } from '../shared/enums/SaveMode';
import { DispatchSaveParam } from '../shared/models/DispatchSaveParam';
import { ChangeStatusDialogComponent } from './change-status/change-status-dialog.component';
import { WindowContents } from '../shared/enums/windowContents';
import { DispatchItemBus } from '../shared/models/DispatchItemBus';
import { DbTable } from '../shared/enums/DbTable';
import { ScheduleDispatchesComponent } from './scheduled/schedule-dispatches.component';
import { v_LocationDetailBus } from '../shared/models/v_LocationDetailBus';
import { DisplayNotesComponent } from '../shared/components/display-notes/display-notes.component';
import { DispatchThirdPartyHistoryDialogComponent } from './dispatch-third-party-history-dialog/dispatch-third-party-history-dialog.component';
import { InvoiceEstimateDialogComponent } from '../invoices/invoice-estimate/invoice-estimate-dialog.component';
import { CRUDActions } from '../shared/enums/CRUDActions';
import { ConfirmOutput } from '../shared/models/ConfirmOutput';
import { CPDialogResult } from '../shared/enums/CPDialogResult';
import { DispatchKudosComponent } from './kudos/dispatch-kudos.component';
import { DispatchPartsComponent } from './parts/used/dispatch-parts.component';
import { MessageInfo } from '../shared/models/MessageInfo';
import { InvoiceChecklistComponent } from '../invoices/invoice-checklist/invoice-checklist.component';
import { CPSearchComponent } from '../shared/search/cp-search/cp-search.component';
import { CallbackRFBCheckComponent } from './callback-rfb-check/callback-rfb-check.component';
import { RefTrackingComponent } from './ref-tracking/ref-tracking.component';
import { GGItem } from '../shared/models/GGItem';
import { CPSearchTargetComponent } from '../shared/search/cp-search/cp-search-target/cp-search-target.component';
import { DispatchCallbackComponent } from './dispatch-callback/dispatch-callback.component';
import { DispatchCallbackBus } from '../shared/models/DispatchCallbackBus';
import { environment } from '../../../environments/environment';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { KudosAndOpportunityComponent } from './kudos-opportunity/kudos-opportunity.component';
import { PrintService } from '../shared/services/print.service';
import { ICPLoader, UseCPLoader } from '../shared/decorators/cploader/cploader-decorator';
import { UseFeatureFlagSet, IFeatureFlagSet } from '../shared/decorators/featureflags/featureflagset-decorator';
import { OrderService } from '../shared/services/order.service';
import { DQOIDispatchDisplaySettings } from '../shared/models/DQOIDisplaySettings';

@UseCPLoader()
@UseFeatureFlagSet()
@Component({
    selector: 'dispatches',
    templateUrl: './dispatches.component.html',
    styleUrls: ['./dispatches.component.scss'],
    standalone: false
})
export class DispatchesComponent extends BaseDQOIComponent<DispatchBus, DispatchesService, AdditionalDispatchData, DispatchPage> {
    compFeatureFlagSet: IFeatureFlagSet = this as any;
    appCode: string = "Dispatch";
    compLoader: ICPLoader = this as any;
    popUp: boolean = false;
    dispatchTitle: string = "Dispatch";
    orderService: OrderService;

    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, svc_dqoi: DQOIService, svc_data: DispatchesService, qry_rd: DQOIReferenceDataQuery, private cd: ChangeDetectorRef, private printService: PrintService, orderService: OrderService) {
        super(globals, featureFlagService, svc_dqoi, qry_rd);
        this.svc_data = svc_data;
        this.addtlDataClass = "AdditionalDispatchData";
        this.pageData = new DispatchPage(svc_data);
        this.searchTarget = SearchTarget.dispatch;
        this.saveMode = SaveMode.all;
        this.setupCheckForm();
        this.orderService = orderService;
    }
    @ViewChild("Notes") notesComp: DispatchNotesComponent;
    @ViewChild("CollNotes") collNotesComp: DisplayNotesComponent;
    @ViewChild("InjuryNotes") injuryNotesComp: DispatchNotesComponent;
    @ViewChild("Assignments") assignmentsComp: DispatchAssignmentsComponent;
    @ViewChild("Attachments") attachmentsComp: WorkOrderAttachmentsComponent;
    @ViewChild("Equipment") equipSvcdComp: DispatchEquipSvcdComponent;
    @ViewChild("PartsReq") partsRequestedComp: DispatchPartsRequestedComponent;
    @ViewChild("Parts") partsComp: DispatchPartsComponent;
    @ViewChild("CustParts") customerSuppliedPartsComp: DispatchCustomerSuppliedPartsComponent;
    @ViewChild("Labor") laborComp: DispatchLaborComponent;
    @ViewChild("ErrorsComp") errorsComp: DispatchErrorsComponent;
    @ViewChild("Kudos") kudosComp: DispatchKudosComponent;
    @ViewChild("KudosAndOpportunity") kudosAndOppComp: KudosAndOpportunityComponent;
    @ViewChild("ChangeStatus") changeStatusComp: ChangeStatusDialogComponent;
    @ViewChild("ScheduleDispatches") scheduleDispatchesComponent: ScheduleDispatchesComponent;
    @ViewChild('dispatchThirdPartyHistoryDialog') public dispatchThirdPartyHistoryDialog: DispatchThirdPartyHistoryDialogComponent;
    @ViewChild('invoiceEstimateDialog') public invoiceEstimateDialog: InvoiceEstimateDialogComponent;
    @ViewChild("CheckList") invoiceChecklistComponent: InvoiceChecklistComponent;
    @ViewChild('cpDispatchSearchCallback') protected cpDispatchSearchCallback: CPSearchComponent;
    @ViewChild("CallbackRFBCheck") callbackRFBCheckComponent: CallbackRFBCheckComponent;
    @ViewChild("refTracking") refTrackingComp: RefTrackingComponent;
    @ViewChild('cpSearchTargetCallback') protected cpSearchTargetCallback: CPSearchTargetComponent;
    @ViewChild('dispatchCallback') protected dispatchCallback: DispatchCallbackComponent;

    @Input() dqoiDispatchDisplaySettings: DQOIDispatchDisplaySettings = new DQOIDispatchDisplaySettings();

    get saveMode_NotesAndCB(): any {
        let saveMode = this.saveModeAfterId;
        if (this.callbackNoteActive) {
            saveMode = this.saveMode;
        }
        return saveMode;
    }
    get saveMode_Notes(): any {
        let saveMode = this.saveMode;
        if (this.hasReferenceData) {
            if (this.serviceMode === "1") {
                saveMode = SaveMode.individual;
            }
        }
        return saveMode;
    }
    get saveMode_Attachments(): any {
        let saveMode = this.saveMode;
        if (this.hasReferenceData) {
            if (this.referenceData.serviceMode === "1" && this.rights.FG2RegularAccess != true) {
                saveMode = SaveMode.individual;
            }
        }
        return saveMode;
    }
    setText() {
        if (this.compFeatureFlagSet.featureFlagSet['ui-hide-zuggit-menu-items-extended'] && this.globals.user.isZuggitUser && !this.dqoiDispatchDisplaySettings?.useCPRefData) {
            this.dispatchTitle = "Sales Order";
        }
    }
    setRequiredFileds() {

        if (this.locationDetail && this.locationDetail.dispatchRequiresPO) {
            this.editForm.get('ponumber').setValidators(Validators.required);
            this.editForm.controls['ponumber'].updateValueAndValidity();
        } else {
            this.editForm.get('ponumber').clearValidators();
            this.editForm.controls['ponumber'].updateValueAndValidity();
        }

    }

    get readOnly_ServiceMode(): boolean {
        return this.serviceMode === "1" ? false : this.readOnly;
    }
    get canEditChild_Notes(): boolean {
        return this.customFormValidation() && ((this.saveMode == SaveMode.individual || !this.readOnly) && ((this.canSave && this.saveMode === SaveMode.all) || this.hasId));
    }
    get canEditChild_Attachments(): boolean {
        return this.customFormValidation() && ((this.saveMode == SaveMode.individual || !this.readOnly) && (this.canSave || this.hasId));
    }
    get isDirty(): boolean {
        return !this.readOnly_ServiceMode && this.hasEditForm && this.editForm.dirty;
    }
    get originalStatusId(): any {
        return this.hasData ? this.data.dispatchStatusId : null;
    }
    get hasOriginalStatusId(): any {
        return this.originalStatusId !== null;
    }
    get accountClassId(): any {
        return this.hasEditForm ? this.editForm.value.accountClassId : (this.hasData ? this.data.accountClassId : null);
    }
    get priorityId(): any {
        return this.hasEditForm ? this.editForm.value.priorityId : (this.hasData ? this.data.priorityId : null);
    }
    get isContractClass(): boolean {
        if ((this.accountClassId === CommonValues.AccountClass_Contract
            || this.accountClassId === CommonValues.AccountClass_Contract_PM)) {
            if (!this.editForm.contains('accountClassSubClassId')) {
                this.editForm.addControl('accountClassSubClassId', new UntypedFormControl('', Validators.required));
            } else {
                this.editForm.get('accountClassSubClassId').setValidators(Validators.required);
                this.editForm.get('accountClassSubClassId').updateValueAndValidity();
            }
            return true;
        } else {
            if (this.editForm.contains('accountClassSubClassId')) {
                this.editForm.get('accountClassSubClassId').clearValidators();
                this.editForm.get('accountClassSubClassId').setValue(null);
                this.editForm.get('accountClassSubClassId').updateValueAndValidity();
            }
            return false;
        }
    }

    get isPMPriority(): boolean {
        if ((this.priorityId === CommonValues.Priority_PM)) {
            if (!this.editForm.contains('prioritySubTypeId')) {
                this.editForm.addControl('prioritySubTypeId', new UntypedFormControl('', Validators.required));
            } else {
                this.editForm.get('prioritySubTypeId').setValidators(Validators.required);
                this.editForm.get('prioritySubTypeId').updateValueAndValidity();
            }
            return true;
        } else {
            if (this.editForm.contains('prioritySubTypeId')) {
                this.editForm.get('prioritySubTypeId').clearValidators();
                this.editForm.get('prioritySubTypeId').setValue(null);
                this.editForm.get('prioritySubTypeId').updateValueAndValidity();
            }
            return false;
        }
    }

    get contractSubClasses(): GGItem[] {
        return this.referenceData?.accountClassesSubClasses.filter(ac => ac.other === this.accountClassId);
    }

    get prioritySubTypes(): GGItem[] {
        return this.referenceData?.prioritySubTypes.filter(ac => ac.other === this.priorityId);
    }

    get customAppSaveValidation(): boolean {
        return this.serviceMode === "0" || this.statusId !== this.originalStatusId ? true : false;
    }
    viewHistory() {

        this.dispatchThirdPartyHistoryDialog.openHistory(this.id);

    }
    viewInvoiceEstimate() {

        this.invoiceEstimateDialog.show(this.id, SearchTarget.dispatch);

    }

    subs_dataScheduledDispatches: Subscription;
    public editForm: UntypedFormGroup = new UntypedFormGroup({
        'dispatchId': new UntypedFormControl(),
        'dispatchNumber': new UntypedFormControl(),
        'companyId': new UntypedFormControl(),
        'customerId': new UntypedFormControl('', Validators.required),
        'locationId': new UntypedFormControl('', Validators.required),
        'dispatchStatusId': new UntypedFormControl('', Validators.required),
        'priorityId': new UntypedFormControl('', Validators.required),
        'notToExceed': new UntypedFormControl(),
        'ponumber': new UntypedFormControl(),
        'wonumber': new UntypedFormControl(),
        'quoteNumber': new UntypedFormControl(),
        'invoiceNumber': new UntypedFormControl(),
        'foremanId': new UntypedFormControl(),
        'jobClassificationId': new UntypedFormControl(),
        'dispatchClassificationId': new UntypedFormControl(),
        'dispatchRepairCatId': new UntypedFormControl(),
        'dispatchProblemCodeId': new UntypedFormControl(),
        'dispatchActionCodesId': new UntypedFormControl(),
        'dispatchSummaryCodeId': new UntypedFormControl(),
        'dispatchCauseCodesId': new UntypedFormControl(),
        'dispatchFailureCodesId': new UntypedFormControl(),
        'receivedDateTime': new UntypedFormControl(null, Validators.required),
        'receivedById': new UntypedFormControl('', Validators.required),
        'estimatedBeginDate': new UntypedFormControl(),
        'estimatedEndDate': new UntypedFormControl(),
        'estimatedCost': new UntypedFormControl(),
        'isConstruction': new UntypedFormControl(false),
        'isProgressBill': new UntypedFormControl(false),
        'contractPrice': new UntypedFormControl(null as number),
        'profit1': new UntypedFormControl(null as number),
        'profit2': new UntypedFormControl(null as number),
        'dispatchReason': new UntypedFormControl(),
        'accountClassSubClassId': new UntypedFormControl(''),
        'purchaserPersonId': new UntypedFormControl(),
        'accountClassId': new UntypedFormControl('', Validators.required),
        'acctMgr': new UntypedFormControl(),
        'regionName': new UntypedFormControl(),
        'whoCalledName': new UntypedFormControl('', Validators.required),
        'refTrackNbr': new UntypedFormControl(),
        'callbackId': new UntypedFormControl(),
        'callbackNumber': new UntypedFormControl(),
        'insertDt': new UntypedFormControl(),
        'insertUserId': new UntypedFormControl(),
        'updateDt': new UntypedFormControl(),
        'updateUserId': new UntypedFormControl(),
        'slaDate': new UntypedFormControl('', this.globals.user.isZuggitUser ? null : Validators.required),
        'slaTime': new UntypedFormControl('', this.globals.user.isZuggitUser ? null : Validators.required),
        'isCallback': new UntypedFormControl(),
        'rankOrderId': new UntypedFormControl(),
        'prioritySubTypeId': new UntypedFormControl(''),
    });

    setForm() {

        this.editForm.patchValue({
            dispatchId: this.data.dispatchId,
            dispatchNumber: this.data.dispatchNumber,
            companyId: this.data.companyId,
            customerId: this.data.customerId,
            locationId: this.data.locationId,
            dispatchStatusId: this.data.dispatchStatusId,
            priorityId: this.data.priorityId,
            notToExceed: this.data.notToExceed,
            ponumber: this.data.ponumber,
            wonumber: this.data.wonumber,
            foremanId: this.data.foremanId,
            jobClassificationId: this.data.jobClassificationId,
            dispatchClassificationId: null,
            dispatchRepairCatId: this.data.dispatchRepairCatId,
            dispatchProblemCodeId: this.data.dispatchProblemCodeId,
            dispatchActionCodesId: this.data.dispatchActionCodesId,
            dispatchSummaryCodeId: this.data.dispatchSummaryCodeId,
            dispatchCauseCodesId: this.data.dispatchCauseCodesId,
            dispatchFailureCodesId: this.data.dispatchFailureCodesId,
            receivedDateTime: this.data.receivedDateTime,
            receivedById: this.data.receivedById,
            estimatedBeginDate: this.data.estimatedBeginDate,
            estimatedEndDate: this.data.estimatedEndDate,
            estimatedCost: this.data.estimatedCost,
            isConstruction: this.data.isConstruction,
            isProgressBill: this.data.isProgressBill,
            contractPrice: this.data.contractPrice,
            dispatchReason: this.data.dispatchReason,
            accountClassId: this.data.accountClassId,
            accountClassSubClassId: this.data.accountClassSubClassId,
            purchaserPersonId: this.data.purchaserPersonId,
            whoCalledName: this.data.whoCalledName,
            refTrackNbr: this.data.refTrackNbr,
            callbackId: this.data.callbackId,
            insertDt: this.data.insertDt,
            insertUserId: this.data.insertUserId,
            updateDt: this.data.updateDt,
            updateUserId: this.data.updateUserid,
            slaDate: this.data.slaDate,
            slaTime: this.data.slaTime,
            isCallback: this.data.isCallback,
            rankOrderId: this.data.rankOrderId,
            prioritySubTypeId: this.data.prioritySubTypeId
        });
        this.setValidators();
    }

    public noWhitespaceValidator(control: FormControl) {
        return (control.value || '').trim().length ? null : { 'whitespace': true };
    }
    setFormAddtl() {
        this.editForm.patchValue({
            quoteNumber: this.addtlData.quoteNumber,
            invoiceNumber: this.addtlData.invoiceNumber,
            profit1: this.addtlData.profit1,
            profit2: this.addtlData.profit2,
            acctMgr: this.addtlData.acctMgr,
            regionName: this.addtlData.regionName,
            callbackNumber: this.addtlData.callbackNumber
        });

    }
    setFormLocation(data: v_LocationDetailBus) {
        if (!this.hasId) {
            this.editForm.patchValue({
                notToExceed: data.nte
            });
        }
    }
    defaultDispatchHistoryDaysBack: number = 60;
    dispatchHistoryDaysBack: number = 60;
    get hasAccountClass(): boolean {
        return this.hasEditForm && CommonFunctions.hasGuidValue(this.editForm.value.accountClassId);
    }
    get hasStatus(): boolean {
        return this.hasEditForm && CommonFunctions.hasGuidValue(this.editForm.value.dispatchStatusId);
    }
    get hasPriority(): boolean {
        return this.hasEditForm && CommonFunctions.hasGuidValue(this.editForm.value.priorityId);
    }
    get hasRcvdDate(): boolean {
        return this.hasEditForm && CommonFunctions.hasValue(this.editForm.value.receivedDateTime);
    }
    get hasRcvdPerson(): boolean {
        return this.hasEditForm && CommonFunctions.hasGuidValue(this.editForm.value.receivedById);
    }
    get callbackId(): any {
        return this.hasEditForm ? this.editForm.value.callbackId : null;
    }
    get hasCallbackId(): boolean {
        return CommonFunctions.hasGuidValue(this.callbackId);
    }
    get statusId(): any {
        return this.hasStatus ? this.editForm.value.dispatchStatusId : null;
    }
    get canAssignTech(): boolean {
        let can: boolean = this.isValid && this.serviceMode !== '1' && this.canCloseOverRide();
        return can;
    }
    get canScheduleDispatches(): boolean {
        return this.serviceMode !== '1';
    }
    get canEmail(): boolean {
        return this.serviceMode !== '1';
    }
    get canPrint(): boolean {
        return this.hasId;
    }
    get hasWONumber(): boolean {
        return this.hasEditForm ? CommonFunctions.hasStringValue(this.editForm.value.wonumber) : false;
    }
    customFormValidation() {
        let canSave = super.customFormValidation();
        if (this.reqWO) {
            canSave = canSave && this.hasWONumber;
        }
        return canSave;
    }
    customerCBOChanged(item: any) {
        if (CommonFunctions.hasValue(item)) {
            if (this.hasReferenceData) {
                if (item.value === CommonValues.CustomerId_ClimatePros && !this.rights.CreateCPIDispatch) {
                    //return to previous value if user lacks permissions to select the value that was chosen
                    this.customerChanged(this.data?.customerId);
                    this.locationChanged(this.data?.locationId);
                    let notificationMessage = 'You do not have the permissions to select ' + item.description + '.';
                    this.globals.notifyError(notificationMessage, true);
                }
                else if (!this.hasId && this.referenceData.isCustomerOnHold(item.value)) {
                    this.cnfShow("Are you sure you want to continue creating a Dispatch?", CRUDActions.Create, item, "This customer is on hold!", "ONHOLD");
                }
                else {
                    this.customerChanged(item.value);
                }
            }
        }
        else {
            this.customerChanged(null);
        }
    }

    customCustomerChanged() {
        this.setValidators();
    }

    setValidators() {
        this.setText();
        if (this.compFeatureFlagSet.featureFlagSet['dispatches-require-wo-validation-for-customer-reqworknum-bit']) {
            if (this.reqWO) {
                this.editForm.controls['wonumber'].setValidators([Validators.required, this.noWhitespaceValidator]);
                this.editForm.controls['wonumber'].updateValueAndValidity();
            } else {
                this.editForm.controls['wonumber'].clearValidators();
                this.editForm.controls['wonumber'].updateValueAndValidity();
            }
        }
    }

    onCPWindowClosed(e) {
        this.refreshData(DbTable.DispatchAssignments);
        super.onCPWindowClosed(e);
    }
    assignTech(personToAssignId: any = null) {
        let dataObj: DispatchItemBus = new DispatchItemBus();
        dataObj.dispatchId = this.data.dispatchId;
        dataObj.dispatchNumber = this.data.dispatchNumber;
        dataObj.locationId = this.data.locationId;
        dataObj.customerId = this.data.customerId;
        dataObj.personToAssignId = personToAssignId;
        dataObj.from = SearchTarget.dispatch;
        if (!this.hasId || this.isDirty) {
            this.setAfterSaveMessage({ messageType: MessageType.assignNewTech, value: personToAssignId, values: personToAssignId, messageSubject: null, message: null, dqoiIndex: null, searchTarget: SearchTarget.any, refreshTarget: null });
            this.save();
        }
        else {
            this.cpPopWindow({ contentType: WindowContents.assignTech, boardData: { assignDispatch: dataObj } });
        }
    }
    origGridData: DispatchSummary[] = new Array();
    gridData: DispatchSummary[];
    get emailTitle(): string {
        return this.hasId && this.customerId === CommonValues.Customer_WalMart ? 'WalMart Email' : 'Email';
    }
    email() {
        this.mainLoadingOn(false, this.compLoader);
        if (this.customerId === CommonValues.Customer_WalMart) {
            this.svc_data.getWalMartEmail(this.id).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    let email: Email = new Email(info.primaryReturn);
                    let strEmail: string = "mailto: " + email.to + " ?subject=" + email.subjectEncoded() + "&body=" + email.bodyEncoded();

                    window.location.assign(strEmail);
                    if (info.warning) {
                        this.globals.notifyWarning(info.message, true);
                    }
                }
                else {
                    this.saveError("Error Trying to Construct Email: " + info.message);
                }
                this.mainLoadingOff(false, this.compLoader);
            });
        }
        else {
            this.svc_data.getEmailDefaultsForDispatch(this.id).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    let email: Email = new Email(info.primaryReturn);
                    window.location.assign("mailto: ?subject=" + email.subjectEncoded() + "&body=" + email.bodyEncoded());
                }
                else {
                    this.saveError("Error Trying to Construct Email: " + info.message);
                }
                this.mainLoadingOff(false, this.compLoader);
            });
        }
    }

    createNew(busObj: DispatchBus) {
        return new DispatchBus(busObj);
    }

    getData() {
        super.getData();
        CommonFunctions.unsubscribe(this.subs_data);
        this.subs_data = this.svc_data.get(this.id).subscribe(data => {
            if (!data) {
                console.error("Unable to find resource with id", this.id);
                return; // no sense moving on errors will happen in setData
            }
            this.setData(data);
        });
    }

    fieldInvoice() {
        var link = environment.FieldInvoice + this.addtlData.fieldInvoiceQueueId;
        window.open(link, "_blank");
    }

    getAddtlData() {
        CommonFunctions.unsubscribe(this.subs_dataAddInfo);
        this.subs_dataAddInfo = this.svc_data.GetAdditionalDispatchData(this.id).subscribe(data => {
            this.addtlData = new AdditionalDispatchData(data);
            if (this.addtlData.dispatchNotesInjury) {
                for (let i = 0; i < this.addtlData.dispatchNotesInjury.length; i++) {
                    if (!this.addtlData.dispatchNotesInjury[i].personName) {
                        this.addtlData.dispatchNotesInjury[i].personName = this.referenceData.getPerson(this.addtlData.dispatchNotesInjury[i].dispatchNotesPersonId);
                    }
                }
            }
            this.setFormAddtl();
            this.pageData.getDispatchAttachments(this.id);
            this.pageData.getLabor(this.id);
            this.pageData.getAssignments(this.id, this.referenceData);
            //this.pageData.getDispatchNotes(this.id); //.dispatchNotes = this.addtlData.dispatchNotes;
        });
    }

    checkCustomerInactive(id: any) {
        this.referenceData.getCustomerAddIfInactive(id);
    }
    setData(data: DispatchBus) {
        this.checkCustomerInactive(data.customerId);
        this.customerChanged(data.customerId);
        this.locationChanged(data.locationId);
        super.setData(data);
        if (CommonFunctions.hasValue(this.afterSaveMessage)) {
            let msg = _.cloneDeep(this.afterSaveMessage);

            this.setAfterSaveMessage(null);
            msg = this.setAfterSaveMessagePropertiesAfterSave(msg);

            this.parentMessage(msg, this.compLoader);
        }
    }
    protected setAfterSaveMessagePropertiesAfterSave(msg: Message) {
        if (msg.messageType === MessageType.createOrderFromParts) {
            if (CommonFunctions.hasArrayElementValue(msg.values)) {
                msg.value = this.id;
                for (let i = 0; i < msg.values.length; i++) {
                    msg.values[i].dispatchId = this.id;
                }
            }
            //addToOrder: DispatchPartsRequestedBus[]
        }
        return msg;
    }
    scheduleDispatchesActive: boolean = false;
    scheduleDispatchesClosed(e: any) {
        this.scheduleDispatchesActive = false;
    }
    scheduleDispatches() {
        this.scheduleDispatchesComponent.setup(null);
        this.scheduleDispatchesActive = true;
    }

    override customParentMessage(e: Message) {

        if (e.messageType === MessageType.assignNewTech) {
            this.assignTech(null);
        }
        else if (e.messageType === MessageType.reassignTech) {
            this.assignTech(e.values);
        }
        else if (e.messageType === MessageType.gotoDispatchHistory) {
            let url: string = "/dispatch/history/" + this.customerId + "/" + this.locationId;
            console.log("url: ", url);
            this.navigate(url);
        }
    }
    refreshData(refreshTarget: DbTable) {
        if (!CommonFunctions.hasValue(refreshTarget)) {
            super.refreshData(null);
        }
        switch (refreshTarget) {
            case DbTable.DispatchAssignments:
                this.pageData.getAssignments(this.data.dispatchId, this.referenceData);
                break;
        }
    }
    //Save Dispatch according to that setting which is a 1lockdown setting
    saveServiceMode1() {
        if (this.hasStatus && this.statusId !== this.data.dispatchStatusId) {
            let param: CommonParam = new CommonParam();
            param.addParam("dispatchId", this.id);
            param.addParam("newStatusId", this.statusId);
            this.svc_data.changeDispatchStatus(param).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    this.saveSuccess();
                }
                else {
                    this.saveError(info.message);
                }
            });
        }
    }
    checkIsOnHold(): boolean {
        let isOnHold: boolean = false;
        if (this.hasReferenceData) {
            if (!this.hasId && this.referenceData.isCustomerOnHold(this.customerId)) {
                this.cnfShow("Are you sure you want to continue creating a Dispatch?", CRUDActions.Create, this.data, "This customer is on hold!", "ONHOLD");
            }
        }
        return isOnHold;
    }

    canSaveChildren(): BaseMessageInfo {
        let msgInfo = super.canSaveChildren();
        if (CommonFunctions.hasValue(this.laborComp) && this.laborComp.isEditing && !this.laborComp.canSaveForm) {
            let msg: MessageInfo = this.laborComp.cannotSaveMessage(0);
            msgInfo.addMessage(msg);
            msgInfo.warning = true;
        }

        if (CommonFunctions.hasValue(this.notesComp) && this.notesComp.isEditing && !this.notesComp.canSaveForm) {
            let msg: MessageInfo = this.notesComp.cannotSaveMessage(0);
            msgInfo.addMessage(msg);
            msgInfo.warning = true;
        }
        if (CommonFunctions.hasValue(this.injuryNotesComp) && this.injuryNotesComp.isEditing && !this.injuryNotesComp.canSaveForm) {
            let msg: MessageInfo = this.injuryNotesComp.cannotSaveMessage(0);
            msgInfo.addMessage(msg);
            msgInfo.warning = true;
        }
        if (CommonFunctions.hasValue(this.assignmentsComp) && this.assignmentsComp.isEditing && !this.assignmentsComp.canSaveForm) {
            let msg: MessageInfo = this.assignmentsComp.cannotSaveMessage(0);
            msgInfo.addMessage(msg);
            msgInfo.warning = true;
        }
        if (CommonFunctions.hasValue(this.attachmentsComp) && this.attachmentsComp.isEditing && !this.attachmentsComp.canSaveForm) {
            let msg: MessageInfo = this.attachmentsComp.cannotSaveMessage(0);
            msgInfo.addMessage(msg);
            msgInfo.warning = true;
        }
        if (CommonFunctions.hasValue(this.equipSvcdComp) && this.equipSvcdComp.isEditing && !this.equipSvcdComp.canSaveForm) {
            let msg: MessageInfo = this.equipSvcdComp.cannotSaveMessage(0);
            msgInfo.addMessage(msg);
            msgInfo.warning = true;
        }
        if (CommonFunctions.hasValue(this.partsRequestedComp) && this.partsRequestedComp.isEditing && !this.partsRequestedComp.canSaveForm) {
            let msg: MessageInfo = this.partsRequestedComp.cannotSaveMessage(0);
            msgInfo.addMessage(msg);
            msgInfo.warning = true;
        }
        if (CommonFunctions.hasValue(this.partsComp) && this.partsComp.isEditing && !this.partsComp.canSaveForm) {
            let msg: MessageInfo = this.partsComp.cannotSaveMessage(0);
            msgInfo.addMessage(msg);
            msgInfo.warning = true;
        }
        if (CommonFunctions.hasValue(this.customerSuppliedPartsComp) && this.customerSuppliedPartsComp.isEditing && !this.customerSuppliedPartsComp.canSaveForm) {
            let msg: MessageInfo = this.customerSuppliedPartsComp.cannotSaveMessage(0);
            msgInfo.addMessage(msg);
            msgInfo.warning = true;
        }
        if (CommonFunctions.hasValue(this.errorsComp) && this.errorsComp.isEditing && !this.errorsComp.canSaveForm) {
            let msg: MessageInfo = this.kudosComp.cannotSaveMessage(0);
            msgInfo.addMessage(msg);
            msgInfo.warning = true;
        }
        if (CommonFunctions.hasValue(this.kudosComp) && this.kudosComp.isEditing && !this.kudosComp.canSaveForm) {
            let msg: MessageInfo = this.kudosComp.cannotSaveMessage(0);
            msgInfo.addMessage(msg);
            msgInfo.warning = true;
        }
        if (CommonFunctions.hasValue(this.kudosAndOppComp) && this.kudosAndOppComp.isEditing && !this.kudosAndOppComp.canSaveForm) {
            let msg: MessageInfo = this.kudosAndOppComp.cannotSaveMessage(0);
            msgInfo.addMessage(msg);
            msgInfo.warning = true;
        }

        return msgInfo;
    }
    saveAll() {
        if (this.serviceMode === "1") {
            this.saveServiceMode1();
        }
        else {
            this.mainLoadingOn(true, this.compLoader);
            let now: Date = DateFunctions.getDateNow();
            let busObj: DispatchSaveParam = new DispatchSaveParam(this.data);
            busObj.setFromForm(this.editForm.value);
            busObj.setCommon(this.globals.userId, now, this.globals.companyId);
            busObj.setBeforeSave();
            if (this.callbackNote) {
                busObj.callbackNote = this.callbackNote;
            }
            // busObj.copyData(this.addtlData, this.pageData);
            if (CommonFunctions.hasValue(this.notesComp) && this.saveMode === this.saveModeAfterId) {
                busObj.notes = _.cloneDeep(this.notesComp.getChanged());
                busObj.addDeletedItems(this.notesComp.getDeletedItems());
            }
            if (CommonFunctions.hasValue(this.injuryNotesComp)) {
                busObj.injuryNotes = _.cloneDeep(this.injuryNotesComp.getChanged());
                busObj.addDeletedItems(this.injuryNotesComp.getDeletedItems());
            }
            if (CommonFunctions.hasValue(this.assignmentsComp)) {
                busObj.assignments = _.cloneDeep(this.assignmentsComp.getChanged());
                busObj.addDeletedItems(this.assignmentsComp.getDeletedItems());
            }
            if (CommonFunctions.hasValue(this.attachmentsComp) && this.saveMode === this.saveModeAfterId) {
                busObj.attachments = _.cloneDeep(this.attachmentsComp.getChanged());
                busObj.addDeletedItems(this.attachmentsComp.getDeletedItems());
            }
            if (CommonFunctions.hasValue(this.equipSvcdComp)) {
                busObj.equipment = _.cloneDeep(this.equipSvcdComp.getChanged());
                busObj.addDeletedItems(this.equipSvcdComp.getDeletedItems());
            }
            if (CommonFunctions.hasValue(this.partsRequestedComp)) {
                busObj.partsReq = _.cloneDeep(this.partsRequestedComp.getChanged());
                busObj.addDeletedItems(this.partsRequestedComp.getDeletedItems());
            }
            if (CommonFunctions.hasValue(this.partsComp)) {
                busObj.parts = _.cloneDeep(this.partsComp.getChanged());
                busObj.addDeletedItems(this.partsComp.getDeletedItems());
            }
            if (CommonFunctions.hasValue(this.customerSuppliedPartsComp)) {
                busObj.custParts = _.cloneDeep(this.customerSuppliedPartsComp.getChanged());
                busObj.addDeletedItems(this.customerSuppliedPartsComp.getDeletedItems());
            }
            if (CommonFunctions.hasValue(this.laborComp)) {
                busObj.labor = _.cloneDeep(this.laborComp.getChanged());
                busObj.addDeletedItems(this.laborComp.getDeletedItems());
            }
            if (CommonFunctions.hasValue(this.errorsComp)) {
                busObj.errors = _.cloneDeep(this.errorsComp.getChanged());
                busObj.addDeletedItems(this.errorsComp.getDeletedItems());
            }
            if (CommonFunctions.hasValue(this.kudosComp)) {
                busObj.kudos = _.cloneDeep(this.kudosComp.getChanged());
                busObj.addDeletedItems(this.kudosComp.getDeletedItems());
            }
            if (CommonFunctions.hasValue(this.kudosAndOppComp)) {
                busObj.kudosAndOpp = _.cloneDeep(this.kudosAndOppComp.getChanged());
                busObj.addDeletedItems(this.kudosAndOppComp.getDeletedItems());
            }
            if (CommonFunctions.hasValue(this.refTrackingComp)) {
                busObj.refTracking = _.cloneDeep(this.refTrackingComp.getChanged());
                busObj.addDeletedItems(this.refTrackingComp.getDeletedItems());
            }            ////   busObj.billingGeographyInfo = null;
            if (CommonFunctions.hasValue(this.dispatchCallback)) {
                let cbParam: CommonParam = this.dispatchCallback.getDataForSave();
                let cbData: DispatchCallbackBus = cbParam.getParam("Data");
                busObj.callbackSystemIdNote = cbData.callbackSystemIdNote;

            }            ////   busObj.shippingGeographyInfo = null;
            if (busObj.dispatchStatusId == CommonValues.Dispatch_ForConstructionReview && !this.isConstruction) {
                this.lockEdit = true;
            }
            this.svc_data.saveAll(busObj).subscribe((info: DispatchMessageInfo) => {
                info = new DispatchMessageInfo(info);
                console.log("disp-saveall-as: ", info);
                if (!info.saveError) {
                    //  let dataObj: InvoiceBus = new InvoiceBus(info.invoice);
                    this.clear();
                    this.getDataFromId(info.dispatch.dispatchId);
                    this.saveSuccess();
                    if (!busObj.hasId) {
                        this.setDQOIItem(info.dispatch.dispatchId);
                    }
                    if (info.warning) {
                        if (info.underConstructionWarrantyFlag == true) {
                            let okButtonText = ""; // info.saveError ? "" : "Assign Tech";
                            let message: MessageInfo = info.getMessage();

                            this.cnfShow(message.message, CRUDActions.Create, null, message.title, null, true);
                        }
                    }
                }
                else {
                    this.lockEdit = false;
                    this.saveError(info.message);
                }
                this.mainLoadingOff(true, this.compLoader);
            });
        }
    }
    refreshDQOI() {
        let id: any = this.id;
        this.clear();
        this.getDataFromId(id);
    }
    protected resetData(dqoiItem: DQOIItem) {
        super.resetData(dqoiItem);
        if (dqoiItem.hasDispatchId) {
            this.id = dqoiItem.dispatchId;
            this.getData();
        }
    }
    refTrackingCompleteStatus(): number {//0-Not Required, 1-Not Complete, 2-Complete
        let req = 0;
        if (this.pageData.hasAttachments_Refrigerant) {
            if (this.addtlData.getRefTrackingStatus() == 2) {
                req = 2;
            }
            else {
                req = 1;
            }
        }

        return req;
    }
    setDQOIItem(id: any) {
        let item: DQOIItem = this.svc_dqoi.getDQOIItem(this.dqoiIndex);
        let busObj: DQOIItem = new DQOIItem(item);
        busObj.dispatchId = id;
        this.svc_dqoi.setDQOIItem(busObj);
    }
    setDQOIState() {
        let data: DQOIState = this.svc_dqoi.getDQOIState();

        data.dispatchId = this.data.dispatchId;
        if (!this.settingFromDQOIState) {
            data.customerId = this.data.customerId;
            data.invoiceId = this.data.invoiceId;
            data.quoteId = this.data.quoteId;
        }

        this.svc_dqoi.nextDQOIState(data);
        this.settingFromDQOIState = false;

        if (CommonFunctions.hasValue(this.dqoiIndex) && this.dqoiIndex > 0) {
            let item: DQOIItem = this.svc_dqoi.getDQOIItem(this.dqoiIndex);
            this.setCommon(item);
        }
    }

    protected setCommon(dqoiItem: DQOIItem) { }
    afterDataSet() {
        super.afterDataSet();
        if (this.hasId && !this.isAdded) {
            this.refreshDQOIItem(this.id);
        }
    }

    onTabSelect(e: SelectEvent) {
        if (e.title === 'Dispatch History') { //&& !this.pageData.hasHistory) {
            let date: Date = DateFunctions.getDateBackNDays(this.dispatchHistoryDaysBack);
            this.pageData.getHistory(this.locationId, date);
        }
        else if (e.title === 'Assignments' && !this.pageData.hasAssignments) {
            this.pageData.getAssignments(this.data.dispatchId, this.referenceData);
        }
        else if (e.title === 'Labor' && !this.pageData.hasLabor) {
            this.pageData.getLabor(this.data.dispatchId);
        }
        else if (e.title === 'Parts' && !this.pageData.hasPartsRequested) {
            this.pageData.getPartsRequested(this.data.dispatchId);
            this.pageData.getParts(this.data.dispatchId, this.referenceData);
            this.pageData.getCustParts(this.data.dispatchId);
            if (!this.pageData.hasAssignments) {
                this.pageData.getAssignments(this.data.dispatchId, this.referenceData);
            }
        }
        else if (e.title === 'Serviced Equipment' && !this.pageData.hasEquipmentSvcd) {
            //            this.pageData.getEquipmentSvcd(this.data.dispatchId); //, 'SVCDEQUIP');
            this.pageData.getData(this.data.dispatchId, 'SVCDEQUIP');

            //this.pageData.getData(id, code);
        }
        else if (e.title === 'Status History' && !this.pageData.hasStatusHist) {
            this.pageData.getStatusHistory(this.data.dispatchId);
        }
        else if (e.title === 'Attachments' && !this.pageData.hasAttachments) {
            this.pageData.getDispatchAttachments(this.data.dispatchId);
        }
        else if (e.title === 'Photos' && !this.pageData.hasImages) {
            this.pageData.getImages(this.data.dispatchId);
        }
        else if (e.title === 'Kudos' && !this.pageData.hasDispatchKudos) {
            this.pageData.getDispatchKudos(this.data.dispatchId);
        }
        else if (e.title === 'Opportunity' && !this.pageData.hasErrors) {
            this.pageData.getErrors(this.data.dispatchId);
        }
        else if (e.title === 'Kudos & Opportunity' && !this.pageData.hasKudosAndOpportunities) {
            this.pageData.getKudosAndOpportunities(this.data.dispatchId);
        }
        else if (e.title === 'Supplier Credits' && !this.pageData.hasVendorCredits) {
            this.pageData.getVendorCredits(this.data.dispatchId);
        }
        else if (e.title === 'Assets' && !this.pageData.hasAssets) {
            this.pageData.getAssets(this.data.dispatchId);
        }
        //else Status History
    }

    onPartsTabSelect(e: SelectEvent) {
        if (e.title === 'Requested' && !this.pageData.hasPartsRequested) {
            this.pageData.getPartsRequested(this.data.dispatchId);
        }
        else if (e.title === 'Ordered' && !this.pageData.hasPartsOrdered) {
            this.pageData.getPartsOrderedAll(this.data.dispatchId);
        }
        else if (e.title === 'Used' && !this.pageData.hasParts) {
            this.pageData.getParts(this.data.dispatchId, this.referenceData);
        }
        else if (e.title === 'Customer Supplied' && !this.pageData.hasCustParts) {
            this.pageData.getCustParts(this.data.dispatchId);
        }
    }
    createDraw() {

    }
    delete() {
        if (this.data.isAdded) {
            this.clear();
        }
        else {
            this.svc_data.deleteDispatch(this.id).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    this.deleteSuccess();
                    this.clear();
                }
                else {
                    this.deleteError(info.message);
                }
            });
        }
    }
    itemDisabled(itemArgs: { dataItem: any, index: any; }) {
        return !itemArgs.dataItem.canSelect;
    }
    disableOnHold(itemArgs: { dataItem: any, index: any; }) {
        return false;
    }
    itemInActive(itemArgs: { dataItem: any, index: any; }) {
        return !itemArgs.dataItem.isActive;
    }
    canEditLab() {
        return this.rights.EditLabor;
    }
    canEditContractPrice() {
        return this.rights.EditContractPrice;
    }
    get canDelete(): boolean {
        return (this.hasId || (this.hasData && this.data.isAdded)) && this.rights.DeleteDispatch && this.serviceMode !== "1";
    }
    refreshMessage(event: any) {
        this.pageData.getDispatchAttachments(this.id);

    }
    canEditValue: boolean = false;
    canEditInFinanceValue: boolean = false;
    canAddPartsToOrderValue: boolean = false;
    canEditChild_NotesValue: boolean = false;
    canEditChild_AttachmentsValue: boolean = false;
    public setupCheckFormLocal() {
        this.canEditValue = this.canEdit;
        this.canEditInFinanceValue = this.canEditInFinance;
        this.canAddPartsToOrderValue = this.canAddPartsToOrder;
        this.canEditChild_NotesValue = this.canEditChild_Notes;
        this.canEditChild_AttachmentsValue = this.canEditChild_Attachments;

    }

    get canAddPartsToOrder(): boolean {
        let can: boolean = this.canEdit && this.data.dispatchStatusId != CommonValues.Dispatch_ReadyForBilling;
        return can;
    }
    get canEdit(): boolean {
        let can: boolean = false;
        if ((this.hasId || (this.hasData && this.data.isAdded))) {
            if (this.canEditBilledOrClosed()) can = true;
            else if (this.canEditReadyForBillingConstruction()) can = true;
            else if (this.data.dispatchStatusId != CommonValues.Dispatch_Billed && this.data.dispatchStatusId != CommonValues.Dispatch_Closed
                && this.data.dispatchStatusId != CommonValues.Dispatch_Canceled && this.data.dispatchStatusId != CommonValues.Dispatch_Declined
                && this.data.dispatchStatusId != CommonValues.Dispatch_Merged
                && this.data.dispatchStatusId != CommonValues.Dispatch_ReadyForBillingConstruction && this.rights.MaintainDispatches) {
                can = true;
            }
            can = can;
        }

        return can;
    }
    canEditBilledOrClosed(): boolean {
        let can: boolean = false;
        if ((this.data.dispatchStatusId == CommonValues.Dispatch_Billed || this.data.dispatchStatusId == CommonValues.Dispatch_Closed
            || this.data.dispatchStatusId == CommonValues.Dispatch_Canceled || this.data.dispatchStatusId == CommonValues.Dispatch_Declined
            || this.data.dispatchStatusId == CommonValues.Dispatch_Merged) && this.rights.EditClosedDispatch) {
            can = true;
        }
        return can;
    }
    canCloseOverRide(): boolean {
        let can: boolean = false;
        if (!this.data || !this.data.dispatchStatusId || (this.data.dispatchStatusId != CommonValues.Dispatch_Billed && this.data.dispatchStatusId != CommonValues.Dispatch_Closed) || this.rights.EditClosedDispatch) {
            can = true;
        }
        return can;
    }
    canEditReadyForBillingConstruction(): boolean {
        let can: boolean = false;
        if ((this.data.dispatchStatusId == CommonValues.Dispatch_ReadyForBillingConstruction) && this.rights.EditReadyForBillingConstruction) {
            can = true;
        }
        return can;
    }
    get showIsConstruction(): boolean {
        return false; // this.statusId === CommonValues.Dispatch_ForConstructionReview ? true : false;
    }
    testSave() {
        let seParam: CommonParam = new CommonParam();

        //seParam.addParam("PrimaryReturn", this.data);
        seParam.addParam("Notes", this.addtlData.dispatchNotes);
        //seParam.addParam("PageData", this.pageData);

        this.svc_data.testParam(seParam).subscribe(data => {
        });

    }

    print() {
        this.compLoader.cpLoader = true;
        this.svc_data.print(this.id).subscribe(data => {
            this.printService.printPdf(data);
            this.compLoader.cpLoader = false;
        });
    }
    statusCBOChanged(item: GItem) {
        let temp = this.refTrackingCompleteStatus();
        console.log("statusCBOChanged:", item.value, CommonValues.Dispatch_ReadyForBilling, temp);
        if (item.value == CommonValues.Dispatch_ReadyForBilling && this.refTrackingCompleteStatus() == 1) {
            this.cnfShowSomeGeneralMessage("Refrigerant Tracking is Not Complete!", "Cannot Set to Ready For billing");
            this.patchStatus(this.data.dispatchStatusId);
        }
        else if (item.value == CommonValues.Dispatch_Bill_DiscreteReview && this.data.dispatchStatusId != CommonValues.Dispatch_ReadyForBilling) {
            this.cnfShowSomeGeneralMessage("Current Status MUST be Ready For billing", "Cannot Set to: Bill: Discrete Review");
            this.patchStatus(this.data.dispatchStatusId);
        }
        else {
            this.checkStatusChange(item.value, this.data.dispatchStatusId);
        }
    }
    subs_statusChangeCheck: Subscription;
    checkStatusChange(newStatusId: any, existingStatusId: any) {
        let param: CommonParam = new CommonParam();
        param.addParam("newStatusId", newStatusId);
        param.addParam("existingStatusId", existingStatusId);
        param.addParam("dispatchId", this.id);
        CommonFunctions.unsubscribe(this.subs_statusChangeCheck);
        this.subs_statusChangeCheck = this.svc_data.checkDispatchStatusChange(param).subscribe((info: DispatchMessageInfo) => {
            if (info.statusChangeOk === false) {
                let title: string = "Status Change";
                if (CommonFunctions.hasGuidValue(info.primaryReturn)) {
                    this.patchStatus(info.primaryReturn);
                    this.globals.notifyWarning(info.message, true);
                    //this.miShow("Change Status Warning: ", info, info, title, null, null);
                }
                else {
                    this.patchStatus(this.data.dispatchStatusId);
                    this.miShow("Change Status Warning: " + (info.saveError ? "Error" : "Warning"), info, info, title, null, null);
                }
            }
            else if (info.askCompleteResources == true) {
                this.changeStatusComp.show(this.id);
            }
            else if (newStatusId === CommonValues.Dispatch_ReadyForBilling && this.hasCallbackId) {
                this.callbackRFBCheckShow();
            }
        });
    }
    patchStatus(statusId: any) {
        this.editForm.patchValue({
            dispatchStatusId: statusId
        });

    }
    completeResourcesConf(e: ConfirmOutput) {
        if (e.dialogResult === CPDialogResult.ok) {
            this.data.completeResources = true;

        }
    }
    canEditRight(code: string) {
        return false;
    }
    canEditLabor() {
        return true;
    }
    callbackSearch: boolean = false;
    doCallbackSearch(code: string) {
        if (code === "CLEAR") {
            this.setCallback(null, null);
        }
        else {
            this.callbackSearch = true;
        }
    }
    setCallback(id: any, number: string) {
        let t_isCB = CommonFunctions.hasGuidValue(id);
        this.editForm.patchValue({
            callbackId: id,
            callbackNumber: number
            //isCallback: t_isCB
        });
        if (!t_isCB) {
            let isCallback = this.editForm.value.isCallback;
            if (isCallback == 1) {
                isCallback = null;
            }
            this.editForm.patchValue({
                foremanId: null,
                isCallback: isCallback
            });
        }
        this.setDirty();
        this.callbackNoteChange();
    }
    callBackSelected(value: any) {
        console.log("callBackSelected: ", value);
        this.callbackSearch = false;
        if (value != null) {
            this.setCallback(value.DispatchId, value.DispatchNumber);
        }
    }

    cpCallbackGoto(number: string) {
        if (this.hasCallbackId) {
            this.showDQOIPopup(this.callbackId, SearchTarget.dispatch);
        }
    }
    cpCallbackValidate(value: any) {

        var skipCheck = false;
        console.log("cpCallbackValidate: ", value);
        if (!value) {

            this.editForm.patchValue({
                callbackNumber: value,
                callbackId: null
            });
            skipCheck = true;
        }
        else {
            var callbackId = this.editForm.controls["callbackId"].value;
            var callbackNumber = this.editForm.controls["callbackNumber"].value;
            if (callbackId) {
                if (callbackNumber === value) { skipCheck = true; }
            }
        }

        if (!skipCheck) {
            //this.dispatchSearchOrder = false;

            this.cpDispatchSearchCallback.validate(value);
        }

    }

    subs_duplicate: Subscription;
    after_hours: Subscription;
    duplicate() {

        //this.saveSuccess("");
        let msg: string = "Would you like to duplicate this dispatch?";
        let title: string = "Duplicate";
        this.cnfShow(msg, CRUDActions.None, null, title, "DUPLICATE_DISP", false);
    }
    createAfterHoursPO() {
        let msg: string = "Would you like to create a Zuggit PO?";
        if (CommonFunctions.hasValue(this.cnfDialog)) {
            this.afterHoursPODialog.show(msg);
        }
    }
    createdAfterHoursPO(po: string) {
        let msg: string = "PO: " + po;
        let title: string = "Zuggit PO Created";
        this.cnfShow(msg, CRUDActions.None, null, title, "CREATE_AFTER_HOURS_PO_COMPLETE", false);
    }
    confirmCustom(data: ConfirmOutput) {
        if (data.dialogResult === CPDialogResult.ok && data.code === "DUPLICATE_DISP") {
            CommonFunctions.unsubscribe(this.subs_duplicate);
            this.subs_duplicate = this.svc_data.duplicateDispatch(this.id).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    let id = info.dcValues.newDispatchId;
                    this.getDataFromId(id);

                }
                else {
                    this.saveError(info.message);
                }
            });

        }
        else if (data.code === "ONHOLD") {
            if (data.dialogResult === CPDialogResult.ok) {
                this.customerChanged(data.data.value);
            }
            else {
                this.customerChanged(null);
            }
        }
        else if (data.code === "CREATE_AFTER_HOURS_PO") {
            if (data.dialogResult === CPDialogResult.ok) {
                this.after_hours = this.orderService.createAfterHoursPO(this.id, data.data).subscribe((info: any) => {
                    if (!info.saveError) {
                        this.createdAfterHoursPO(info.orderNumber);
                    }
                    else {
                        this.saveError(info.message);
                    }
                });
            }
            else {

            }
        }
    }
    doAction(param: CommonParam) {
        let action: string = param.getParam("ACTION");
        let code: string = param.getParam("CODE");
        let id: any = param.getParam("ID");
        switch (action.toUpperCase()) {
            case "GETPAGEDATA":
                if (code === "HISTORY") {
                    let all: boolean = param.getParam("ALL");
                    if (all) {
                        this.dispatchHistoryDaysBack = 0;
                    }
                    else {
                        this.dispatchHistoryDaysBack = this.defaultDispatchHistoryDaysBack;
                    }
                    let date: Date = null;
                    if (this.dispatchHistoryDaysBack > 0) {
                        date = DateFunctions.getDateBackNDays(this.dispatchHistoryDaysBack);
                    }
                    this.pageData.getHistory(this.locationId, date);
                }
                else {
                    this.pageData.getData(id, code, param);
                }
                break;
        }
    }

    refresh() {
        if (!this.refreshToken || this.refreshToken == 0) {
            this.refreshToken = 1;
        }
        //this.mainTab
        let tempId = this.id;
        this.id = undefined;
        this.cd.detectChanges();
        this.id = tempId;
        this.getData();
        this.pageData.clear();
        this.refreshData(null);
        this.refreshToken = 0;
    }

    //Swapping reason div with input
    @ViewChild('reasonBox') reasonBox: ElementRef;
    @ViewChild('reasonBoxEdit') reasonBoxEdit: ElementRef;
    reasonInputRow: number = 4;
    reasonEdit: boolean = false;
    stopEditReason() {
        if (this.hasEditForm) {
            this.data.dispatchReason = this.editForm.value.dispatchReason;
        }
        this.reasonEdit = false;
    }
    editReason() {
        console.log('clicked!');
        this.reasonInputRow = Math.ceil(this.reasonBox.nativeElement.offsetHeight / 22);
        this.reasonEdit = true;
        this.cd.detectChanges();
        this.reasonBoxEdit.nativeElement.focus();
    }
    setup(data: any, code: string = null) {

        if (code === 'CRFROMQUOTE' || code === 'CRFROMINVOICE') {
            this.saveMode = SaveMode.all;
            let dqoiParam: DQOIParam = data as DQOIParam;
            this.dqoiIndex = dqoiParam.dqoiItem.index;
            dqoiParam.dqoiItem.dispatchAdded = true;
            this.svc_dqoi.setDQOIItem(dqoiParam.dqoiItem);
            let info: BaseMessageInfo = dqoiParam.data as BaseMessageInfo;
            this.clear();
            //            this.getData();
            this.customerChanged(this.data.customerId);
            this.locationChanged(this.data.locationId);
            this.addtlData = new AdditionalDispatchData(info.dcValues.addtlData);
            this.pageData = new DispatchPage(this.svc_data);

            var busObj = new DispatchBus(info.primaryReturnView);
            if (code === 'CRFROMINVOICE') {
                busObj.slaDate = DateFunctions.getDateOnly(DateFunctions.getDateNow());
                busObj.slaTime = DateFunctions.getDateNow();
            }
            this.setData(busObj);
            this.setFormAddtl();
            this.edit();
            this.setDirty();
        }
        else if (code === "GOTO") {
            this.getDataFromId(data.id);
        }
    }
    checkListActive: boolean = false;
    doCheckList() {
        this.checkListActive = true;
        let params = [];
        let id: any = CommonValues.Guid_Empty;
        params.push(id);
        params.push(this.customerId);
        params.push(this.locationGeoInfo.stateProvince);
        this.invoiceChecklistComponent.setup(params);
    }
    checkListClosed(e: any) {
        this.checkListActive = false;
    }
    callbackRFBCheckActive: boolean = false;
    callbackRFBCheckShow() {
        this.callbackRFBCheckComponent.setup(this.accountClassId);
        this.callbackRFBCheckActive = true;

    }
    callbackRFBCheckClose(e: any) {
        console.log("callbackRFBCheckClose: ", e);
        this.callbackRFBCheckActive = false;
        if (!e) {
            this.editForm.patchValue({
                dispatchStatusId: this.data.dispatchStatusId
            });
            //change status to original from rfb
        }
        else {
            if (this.editForm.value.accountClassId !== e.accountClassId) {
                this.editForm.patchValue({
                    accountClassId: e.accountClassId
                });
            }
            this.data.callbackRFBNote = e.changeNote;
            //check e.accountClassId - and set if different
        }
    }
    isDispatchCallbackCBOChanged(e: GGItem) {

        if (e) {
            if (e.other == 1) {
                if (!CommonFunctions.hasGuidValue(this.data.callbackId)) {
                    setTimeout(() => {
                        this.doCallbackSearch(null);
                    });
                }
                else {
                    this.callbackNoteChange();
                }
            }
            else if (e.other == 2 || e.other == null) {
                setTimeout(() => {
                    this.doCallbackSearch("CLEAR");
                });
                //this.cpSearchTargetCallback.action(null, "CLEAR");
            }
        }
    }

    callbackNoteActive: boolean = false;
    callbackNote: DispatchNoteBus;
    callbackNoteChange() {
        console.log("dispatch->callbackNoteValueChange: ");
        setTimeout(() => {
            this.callbackNoteActive = true;
        });
    }
    callbackNoteClosed(info: BaseMessageInfo) {
        console.log("dispatch->callbackNoteClosed: ", info);
        setTimeout(() => {
            this.callbackNoteActive = false;
        });
        if (info.primaryReturn) {
            this.callbackNote = info.primaryReturn;
        } else {
            this.callbackNote = null;
        }
    }

    public maxCharLimit: number = 50;
    public characterCount: number = 0;
    public charCounter = `${this.characterCount}/${this.maxCharLimit}`;

    characterCounter(event) {

        this.characterCount = event?.length ?? 0;
        this.charCounter = `${this.characterCount}/${this.maxCharLimit}`;
    }
}
